import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import template from './ui-blocker-with-steps-template.pug';
import { UIBlockerWithStepsViewModel } from './ui-blocker-with-steps-viewmodel';

export class UIBlockerWithStepsView extends Backbone.View {
  initialize({
    i18n,
    steps,
    repository,
    closeBlock,
  }) {
    this.i18n = i18n;
    this.steps = steps;
    this.koModel = new UIBlockerWithStepsViewModel({ steps, i18n });
    this.repository = repository;
    this.closeBlock = _.isFunction(closeBlock) ? closeBlock : _.noop;
  }

  get events() {
    return {
      'click .unblockImportLink': 'goToCampaigns',
      'click #historyLink': 'goToHistoryLink',
    };
  }

  render() {
    const { i18n } = this;

    this.$el.html(template({
      i18n,
      steps: this.steps,
      subTextHtml: i18n.get('Import_UnblockText').replace(
        '{0}',
        `<a id='historyLink' tabindex="0">${i18n.get('Scheduled_Import_History_Page')}</a>`
      ),
    }));
    ko.applyBindings(this.koModel, this.el);
    return this;
  }

  unblockImport() {
    this.repository.setInProcessImportCookie({ importId: this.importId });
    clearInterval(this.timeOut);
  }

  goToCampaigns() {
    this.unblockImport();
    this.closeBlock();
    // closeBlock is async and will clear blocker in next tick.
    // So put redirectToCampaigns also in next tick.
    _.defer(() => {
      this.repository.redirectToCampaigns();
    });
    return true;
  }

  goToHistoryLink() {
    this.unblockImport();
    this.closeBlock();
    _.defer(() => {
      this.repository.redirectToImportScheduleAndHistory();
    });
    return true;
  }

  update({ currentStatusOrder, importId }) {
    this.importId = importId;

    this.koModel.currentStatusOrder((this.steps[currentStatusOrder] && currentStatusOrder) || 0);
  }
}
